import { ReportResponse, CategoryReportData } from '../../../api/reports.api';

interface Props {
  data: ReportResponse<CategoryReportData>;
}

const CategoryReport = ({ data }: Props) => {
  const formatDate = (date: string) => {
    return new Date(date).toLocaleDateString('tr-TR');
  };

  return (
    <div className="p-6">
      {/* Report Header */}
      <div className="mb-6 pb-4 border-b border-gray-200">
        <h2 className="text-2xl font-bold text-gray-900">Kategori Bazlı Cihaz Raporu</h2>
        <div className="mt-2 text-sm text-gray-600">
          <span>Oluşturulma Tarihi: {formatDate(data.generatedAt)}</span>
        </div>
      </div>

      {/* Summary */}
      <div className="mb-6 p-4 bg-gray-50 rounded-lg">
        <h3 className="font-semibold text-gray-900 mb-2">Özet</h3>
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <span className="text-gray-600">Toplam Kategori:</span>
            <span className="ml-2 font-semibold">{data.summary.totalCategories}</span>
          </div>
          <div>
            <span className="text-gray-600">Toplam Cihaz:</span>
            <span className="ml-2 font-semibold">{data.summary.totalDevices}</span>
          </div>
        </div>
      </div>

      {/* Category Data */}
      {data.data.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          Seçilen kriterlere uygun veri bulunamadı
        </div>
      ) : (
        <div className="space-y-6">
          {data.data.map((category) => (
            <div key={category.categoryId} className="border border-gray-200 rounded-lg overflow-hidden">
              {/* Category Header */}
              <div className="bg-gray-100 px-4 py-3 border-b border-gray-200">
                <h4 className="font-semibold text-gray-900 text-lg">{category.categoryName}</h4>
                <div className="mt-2 flex gap-6 text-sm">
                  <span className="text-gray-600">
                    <span className="font-medium">Toplam:</span> {category.totalDevices}
                  </span>
                  <span className="text-green-600">
                    <span className="font-medium">Şubede:</span> {category.available}
                  </span>
                  <span className="text-blue-600">
                    <span className="font-medium">Kullanımda:</span> {category.inUse}
                  </span>
                  <span className="text-yellow-600">
                    <span className="font-medium">Onarımda:</span> {category.underRepair}
                  </span>
                  <span className="text-red-600">
                    <span className="font-medium">Hurda:</span> {category.scrapped}
                  </span>
                </div>
              </div>

              {/* Devices Table */}
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Seri No</th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Ürün</th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Marka</th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Model</th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Durum</th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Kondisyon</th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Şube</th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Konum</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {category.devices.map((device) => (
                      <tr key={device.id} className="hover:bg-gray-50">
                        <td className="px-4 py-3 text-sm text-gray-900">{device.serialNumber}</td>
                        <td className="px-4 py-3 text-sm text-gray-900">{device.productName}</td>
                        <td className="px-4 py-3 text-sm text-gray-600">{device.brand}</td>
                        <td className="px-4 py-3 text-sm text-gray-600">{device.model}</td>
                        <td className="px-4 py-3 text-sm">
                          <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
                            device.status === 'Available' ? 'bg-green-100 text-green-800' :
                            device.status === 'Assigned' ? 'bg-blue-100 text-blue-800' :
                            device.status === 'InRepair' ? 'bg-yellow-100 text-yellow-800' :
                            'bg-red-100 text-red-800'
                          }`}>
                            {device.status === 'Available' ? 'Şubede' :
                             device.status === 'Assigned' ? 'Zimmetli' :
                             device.status === 'InRepair' ? 'Onarımda' :
                             device.status === 'Scrapped' ? 'Hurda' :
                             device.status}
                          </span>
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-600">{device.condition}</td>
                        <td className="px-4 py-3 text-sm text-gray-600">{device.branch}</td>
                        <td className="px-4 py-3 text-sm text-gray-600">{device.location}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoryReport;
